module.exports = __webpack_public_path__ + "static/headshot-4306b6b6d230a6ca2ddae93af1bf6b41.jpeg";